export function freightForwarders(value) {
  return {
    url: `/api/freight_forwarders?nameOrCompany=${value}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function create({ payload }) {
  return {
    url: `/api/delivery_templates`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function remove(id) {
  return {
    url: `/api/delivery_templates/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
  }
}

export function favourites({ params }) {
  return {
    url: `/api/delivery_templates?page=${params.pageNumber}&itemsPerPage=${params.itemsPerPage}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function favouritesByName(name) {
  return {
    url: `/api/delivery_templates?name=${name}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function searchFavourites({ params }) {
  const formatedParams = Object.keys(params)
    .filter((key) => {
      return !!params[key]
    })
    .map((key) => {
      if (key === 'pickupWaypoints' || key === 'receiptWaypoints') {
        return `${key}.postalCode=${params[key].value}`
      }
      if (key === 'freightForwarders') {
        return `${key}.lastname=${params[key].name}`
      }
      return `${key}=${params[key]}`
    })
    .join('&')

  return {
    url: `/api/delivery_templates?${formatedParams}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function favourite({ params }) {
  return {
    url: `/api/delivery_templates/${params.id}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
  }
}

export function modify({ id, payload }) {
  return {
    url: `/api/delivery_templates/${id}`,
    method: 'PATCH',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/merge-patch+json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}
